<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">联邦自雇移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        加拿大联邦自雇移民项目是文化体育艺术工作者通往加拿大的捷径，主要适用于那些可以在文化、艺术、体育等领域内有一定的相关从业经验，自身有一定的专长，并有意愿和能力在加拿大继续从事相关领域工作，为加拿大文化、艺术、体育做出一定贡献的申请人。该项目申请要求简单、流程简便、申请周期快、一步到位全家获得加拿大永居身份。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1、递交申请前5年中至少拥有2年在文化、艺术或体育领域的相关经验（具体请参考相关职业列表），并计划到加拿大以自雇形式从事此方面的工作
              文化、艺术或体育领域的相关经验：
              1) 过去5年中有2年的自雇经验
              2) 过去5年中有2年参加世界性活动的经验
              3) 过去5年中有1年的自雇经验及1年参加世界性活动的经验
            </p>
            <p>2、满足评分表35分或以上</p>
            <p>3、拥有基本的英语或法语能力</p>
            <p>4、申请人需要符合移民局规定的体检和背景安全调查要求</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、加拿大高性价比移民捷径</p>
            <p>2、平凡岗位也能走这条“明星路”</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、免费评估</p>
            <p>2、与嘉诚海外签约</p>
            <p>3、准备材料递交至移民局</p>
            <p>4、收到移民局档案号</p>
            <p>5、收到面试或免面试通知</p>
            <p>6、体检</p>
            <p>7、获批</p>
            <p>8、登陆加拿大</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaZigu'
  }
</script>

<style scoped>

</style>
